var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseFilled = function SvgCloseFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4175 3.87525C11.6128 3.68001 11.9293 3.68006 12.1246 3.87525C12.3198 4.07051 12.3198 4.38702 12.1246 4.58228L8.70659 7.9996L12.1246 11.4176C12.3198 11.6128 12.3198 11.9293 12.1246 12.1246C11.9293 12.3199 11.6128 12.3199 11.4175 12.1246L7.99956 8.70663L4.58224 12.1246C4.38698 12.3199 4.07047 12.3199 3.87521 12.1246C3.68002 11.9293 3.67997 11.6128 3.87521 11.4176L7.29252 7.9996L3.87521 4.58228C3.67994 4.38702 3.67994 4.07051 3.87521 3.87525C4.07047 3.67999 4.38698 3.67999 4.58224 3.87525L7.99956 7.29257L11.4175 3.87525Z",
    fill: "currentColor"
  })));
};
export default SvgCloseFilled;